export default {
  namespaced: true,
  state: {
    nameZH: '',
    nameEN: '',
    openid: "",
    privileges: '',
    token: '',
    worksite: '',
    worksiteName: '',
    roles: [],
    sideRight: [],
    employeeCode: '',
    exWorksites: [],
    wmBoxsites: []
  },
  mutations: {
    update(state, payload) {
      state.nameZH = payload.user.nameZH;
      state.nameEN = payload.user.nameEN;
      state.openid = payload.user.openid;
      state.privileges = payload.user.privileges;
      state.token = payload.user.token;
      state.worksite = payload.user.worksite;
      state.worksiteName = payload.user.worksiteName;
      state.roles = payload.user.roles;
      state.sideRight = payload.user.sideRight;
      state.employeeCode = payload.user.employeeCode;
      state.exWorksites = payload.user.exWorksites;
      state.wmBoxsites = payload.user.wmBoxsites;
    }
  },
  getters: {
    role(state) {
      if (state.roles.includes('超级管理员')) {
        return '超级管理员'
      } else if (state.roles.includes('网点管理员')) {
        return '网点管理员'
      } else if (state.roles.includes('外卖管理员(内部工作人员)')) {
        return '外卖管理员'
      } else if (state.roles.includes('外卖运营管理(外部工作人员)')) {
        return '外卖运营管理'
      } else if (state.roles.includes('外卖客服')) {
        return '外卖客服'
      } else if (state.roles.includes('外卖柜运营管理')) {
        return '外卖柜运营管理'
      } else {
        return '普通员工'
      }
    }
  }
}



// WEBPACK FOOTER //
// ./src/store/userInfo/index.js